export default "<ng-container *ngIf=\"!hide\">\n    <ng-content></ng-content>\n</ng-container>"